import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

/**
 * Function to simplify the banner styling across the Ring of Fire app.
 * - NB: hasAddButton and setOpen is edge-case handling.
 * @param {Object} props
 * @param {React.ReactNode} props.children Text to display in the Banner
 * @param {boolean?} props.hasAddButton Add button (required in the home page's banner usage)
 * @param {((isOpen: boolean) => void)?} props.setOpen Function to open the Add Project dialogue.
 * @returns {JSX.Element}
 */

export default function BannerHeader({ children, hasAddButton, setOpen }) {
    return (
        <Box sx={{ background: '#535988', borderRadius: 2, p: 3, display: 'flex' }}>
            <Typography variant='h5' sx={{ fontWeight: 'bold', color: 'whitesmoke' }}>
                {children}
            </Typography>
            {hasAddButton &&
                <Button
                    className='add-car-btn'
                    variant='outlined'
                    size='medium'
                    sx={{
                        color: "#fff",
                        fontSize: '12px',
                        height: '2.8em',
                        ml: 'auto',
                        float: 'right',
                        border: 'none',
                        '&:hover': {
                            backgroundColor: 'rgba(187, 184, 184, 0.08)', // Change this to your desired hover color
                            border: 'none', // Change this to your desired hover border
                        },
                    }}
                    onClick={() => setOpen(true)}
                >
                    <AddIcon sx={{ mb: 0.25 }}></AddIcon>Add New Biochar Project
                </Button>
            }
        </Box>
    )
}
